import { useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { UpdateOrganisationDescriptionContent } from 'components/Dashboard/DashboardComponent/DashboardUpdateOrganisationDescription';
import ModalComponent from 'components/Common/Modal';
import { store } from 'components/Store';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import DashboardListComponent from 'components/Dashboard/DashboardComponent/DashboardListComponent';
dayjs.extend(timezone);

const RefineBriefingModal = ({ isOpen, setIsOpen }) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;
  const [localKeywordsLists, setLocalKeywordsLists] = useState([]);
  const keywordsLists = localKeywordsLists;

  const [fadedCondition, setFadedCondition] = useState(keywordsLists?.length > 4);
  const [showEditDescription, setShowEditDescription] = useState(false);

  const { newAgencyPlan } = useTopicOrClientWord();

  const handleScroll = (scrollValues) => {
    const { scrollTop, scrollHeight, clientHeight } = scrollValues;
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (scrolledToBottom) {
      setFadedCondition(false);
    } else {
      setFadedCondition(true);
    }
  };

  useEffect(() => {
    if (keywordsLists?.length > 4) {
      setFadedCondition(true);
    }
  }, [keywordsLists]);

  return (
    <>
      <ModalComponent
        maxWidth={710}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        overlayClassName={`react-modal-overlay modal-close-position-adjustment`}
        onAfterClose={() => {
          setShowEditDescription(false);
        }}
        closeFunctionality={
          showEditDescription
            ? () => {
                setShowEditDescription(false);
              }
            : null
        }
      >
        {showEditDescription ? (
          <>
            <UpdateOrganisationDescriptionContent
              isOpenState={{ isOpen: showEditDescription, setIsOpen: showEditDescription }}
            />
          </>
        ) : (
          <>
            <h3 className='topic-title topic-title-email-alerts mb-0 section-title pt-4 pb-3 specific-x-padding-33'>
              <span className='icon-filters  d-inline-block specific-top-margin-4 title-h5-m mr-2' />
              Refine future briefings {newAgencyPlan ? `for ${team?.teamName}` : ''}
            </h3>
            <CustomScrollbar className='simple-scrollbar' autoHeight autoHeightMin='100%' autoHeightMax={`75vh`}>
              <div>
                <div className='d-flex px-3 py-2 text-light-red-100 border-general border-light-red rounded specific-x-margin-33 mb-md-3 mt-md-4 my-2'>
                  <div className='d-flex flex-centered flex-column icon-general-container specific-right-margin-12'>
                    <span className='icon-warning-triangle d-inline-block specific-top-margin-4' />
                  </div>
                  <div>
                    <p className='mb-0'>Changes made here will impact future briefings for all members of your team</p>
                  </div>
                </div>

                <div>
                  <div className='d-flex specific-x-padding-33 specific-top-padding-14 specific-bottom-margin-6'>
                    <div className='d-flex flex-centered flex-column icon-general-container specific-right-margin-12'>
                      <span className='icon-topics d-inline-block specific-top-margin-4' />
                    </div>
                    <div>
                      <p className='mb-0 mb-md-1'>
                        <span className='font-weight-bold'>Topics included in your briefings</span>{' '}
                        {keywordsLists.length > 0
                          ? `(${keywordsLists.filter((item) => item.includedForBriefings).length} of ${
                              keywordsLists.filter((item) => item.id !== null)?.length
                            } selected)`
                          : ''}
                      </p>
                      <p className='mb-0 mb-md-1 light-55-text paragraph-p1'>
                        Choose the topics that feed updates into your briefings
                      </p>
                    </div>
                  </div>
                  <div className='specific-x-padding-33'>
                    <div
                      className={`overflow-hidden specific-left-padding-11 specific-left-padding-xl-28 ${
                        fadedCondition ? 'box-shadow-faded-bottom-white' : ''
                      }`}
                    >
                      <CustomScrollbar
                        className='simple-scrollbar'
                        autoHeight
                        autoHeightMin='100%'
                        autoHeightMax={`163px`}
                        onScroll={(scrollValues) => {
                          handleScroll(scrollValues);
                        }}
                      >
                        <DashboardListComponent setLocalKeywordsLists={setLocalKeywordsLists} path={'refine'} />
                      </CustomScrollbar>
                    </div>
                  </div>
                </div>
                <div
                  className='d-flex list-action-button specific-x-padding-33 pb-3 specific-top-padding-20 pointer refine-briefing-organisation-description position-relative'
                  onClick={() => setShowEditDescription(true)}
                >
                  <div className='d-flex flex-centered flex-column icon-general-container specific-right-margin-12'>
                    <span className='icon-bag font-weight-bold d-inline-block specific-top-margin-4' />
                  </div>
                  <div className='mb-4 flex-grow-1'>
                    <p className='mb-0 mb-md-1 font-weight-md-bold'>Organisation description</p>
                    <p className={`mb-${!!team?.organisationDescription ? '3' : '0'} light-55-text paragraph-p1`}>
                      This helps us highlight the updates most relevant to your work
                    </p>
                    {!!team?.organisationDescription && (
                      <div className='position-relative'>
                        <p
                          className='mb-0 border paragraph-p1 py-2 px-3 bg-blue-hovered-full-opacity hidden-lines hidden-three-lines overflow-hidden'
                          style={{ maxHeight: '87px' }}
                        >
                          {team?.organisationDescription}
                        </p>
                        <div className='position-absolute circle-button-26 bg-main-blue text-white d-flex flex-centered justify-content-center transition-200'>
                          <span className='icon-edit-pencil paragraph-p5' />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CustomScrollbar>
          </>
        )}
      </ModalComponent>
    </>
  );
};

export default RefineBriefingModal;
